/**
 * Simplification tolerance passed to SimplifyJS
 */
export const SIMPLIFICATION_TOLERANCE = 2;

/**
 * Resolution for the longer edge of the drawing surface.
 *
 * Shorter edge's resolution will be proportional.
 */
export const MAX_DRAW_RESOLUTION = 500;

/**
 * Default radius for the pencil, relative to `MAX_DRAW_RESOLUTION`
 */
export const DEFAULT_PENCIL_SIZE = 2;

/**
 * Default radius for the eraser, relative to `MAX_DRAW_RESOLUTION`
 */
export const DEFAULT_ERASER_SIZE = 20;
